import {
  SITE_EMAIL,
  SITE_PHONE_DISPLAY,
  SITE_PHONE_TEL,
} from "./siteConfig";

const ContactInfo = {
  contact_phone: SITE_PHONE_DISPLAY,
  contact_phone_tel: SITE_PHONE_TEL,
  contact_email: SITE_EMAIL,
  address: "Riyadh, Saudi Arabia",
  facebook: "https://facebook.com",
  twitter: "https://facebook.com",
  linkedin: "https://facebook.com",
  instagram: "https://facebook.com",
  youtube: "https://facebook.com",
};

const server_ip = "http://localhost:800";

export { ContactInfo, server_ip };
